


























































import { mixins } from 'vue-class-component'
import { Component, Prop } from 'vue-property-decorator'
import { CardModalLayout } from '@/components/modals/layouts'
import { ModalComponentMixin } from '@/mixins/modal'
import { SearchFilter } from '@/utils'
import { KitOpme } from '@/types/ui/solicitacao-cirurgia'

import KitOpmeCard from './KitOpmeCard.vue'

export type Action = 'criar' | 'editar' | 'clonar' | 'excluir'

type ActionFlags = {
  [key in Action]: boolean
}

interface Props {
  kits: KitOpme[];
  title: string;
  actionFlags: Partial<ActionFlags>;
}

@Component({
  components: {
    CardModalLayout,
    KitOpmeCard,
  },
})
export default class ComponentModalKitOpme extends mixins(ModalComponentMixin) {
  @Prop({ default: [] })
  readonly kits: Props['kits'];

  @Prop({ default: 'Kit de materiais' })
  readonly title: Props['title'];

  @Prop({ type: Object, default: () => ({}) })
  readonly actionFlags: Props['actionFlags'];

  search: string | null = null
  searchFilter = new SearchFilter((kit: KitOpme) => kit.nome)

  get filteredKits() {
    return this.searchFilter.filter(this.kits, this.search || '')
  }

  get emptyListMessage() {
    if (this.kits.length === 0) return 'Nenhum kit disponível'
    if (this.search && this.filteredKits.length === 0) return 'Nenhum resultado encontrado'

    return undefined
  }
}
